import { EventLoggerInstanceName } from 'root-constants'
import { eventLogger } from 'services/eventLogger.service'

type TAnswerValue = string | string[] | boolean | number

export const updateUserPropertiesWithAnswer = (
  answer: Record<string, TAnswerValue>,
): void => {
  eventLogger.updateUserPropertiesByLogger({
    loggersNames: [
      EventLoggerInstanceName.AMPLITUDE,
      EventLoggerInstanceName.RUDDERSTACK,
    ],
    options: {
      ...answer,
    },
  })
}
